import { useController, Control } from "react-hook-form";
import {
  FormControl,
  FormHelperText,
  FormLabel,
  FormLabelProps,
  makeStyles
} from "@material-ui/core";
import {
  ToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonProps
} from "@material-ui/lab";
import cns from "classnames";
import React from "react";
import { ThemeType } from "@theme";

export type ToggleButtonGroupProps = {
  value: any;
  label: React.ReactNode;
  disabled?: boolean;
};

export type Props = {
  label?: string;
  name: string;
  ButtonProps?: ToggleButtonProps;
  LabelProps?: FormLabelProps;
  options: ToggleButtonGroupProps[];
  helperText?: string;
  exclusive?: boolean;
  wrap?: boolean;
  hideErrorLabel?: boolean;
  control?: Control; // optional when used from provider
};

export function ToggleButtonGroupController(props: Props) {
  const classes = useStyles({});
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control
  });

  const helperText = fieldState.error?.message || props.helperText;

  return (
    <FormControl error={fieldState.invalid}>
      <div className={classes.labelRoot}>
        {((fieldState.error && !props.hideErrorLabel) || props.label) && (
          <FormLabel {...props.LabelProps}>{fieldState.error?.message || props.label}</FormLabel>
        )}

        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </div>

      <MuiToggleButtonGroup
        exclusive={props.exclusive}
        value={field.value}
        onChange={(ev, value) => field?.onChange(value)}
        className={cns({ [classes.error]: !!fieldState.error, [classes.wrap]: props.wrap })}
      >
        {props.options?.map((option, i) => {
          return (
            <ToggleButton
              key={i}
              disabled={field.disabled || option.disabled}
              value={option.value}
              {...props.ButtonProps}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </MuiToggleButtonGroup>
    </FormControl>
  );
}

const useStyles = makeStyles((theme: ThemeType) => {
  const errorBorderStyle = `1px solid ${theme.palette.error.main}`;

  return {
    labelRoot: {
      marginBottom: "10px"
    },
    wrap: {
      flexWrap: "wrap",
      "&& > button": {
        margin: "1px",
        borderLeft: `1px solid rgba(0, 0, 0, 0.12)`,
        borderRadius: 4
      },
      "&&[class*='error'] > button": {
        border: errorBorderStyle
      }
    },
    error: {
      "& > button": {
        borderTop: errorBorderStyle,
        borderBottom: errorBorderStyle
      },

      "& > button:first-child": {
        borderLeft: errorBorderStyle
      },

      "& > button:last-child": {
        borderRight: errorBorderStyle
      }
    }
  };
});
